/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";
import template from "templates/modules/featured_promotions_wall";

export default baustein.register("featured-promotions-wall", {
    template,

    getInitialRenderContext() {
        return {
            featured_promotions_wall: {
                content_cards: []
            }
        };
    }
});

